import { useEffect, useState } from "react";
import API from "../../lib/api";

/** Toggle-chip multi-select of the tenant's in-house operatives → [{ user_id, name }]. */
export default function OperativePicker({ value = [], onChange, testPrefix = "operative-picker" }) {
  const [team, setTeam] = useState([]);
  useEffect(() => { API.get("/in-house/team").then(({ data }) => setTeam((data.team || []).filter(u => u.active !== false))).catch(() => {}); }, []);
  const selected = new Set(value.map(v => v.user_id));
  const toggle = (u) => (selected.has(u._id) ? onChange(value.filter(v => v.user_id !== u._id)) : onChange([...value, { user_id: u._id, name: u.name || u.email }]));
  return (
    <div className="flex flex-wrap gap-1.5 items-center" data-testid={testPrefix}>
      {team.length === 0 && <p className="text-xs text-muted-foreground">No in-house operatives yet.</p>}
      {team.map(u => {
        const on = selected.has(u._id);
        return (
          <button key={u._id} type="button" onClick={() => toggle(u)} data-testid={`${testPrefix}-${u._id}`}
            className={`text-xs px-2.5 py-1 rounded-full border transition-colors ${on ? "bg-primary text-white font-semibold border-primary shadow-sm" : "border-border hover:bg-muted text-muted-foreground"}`}>
            {on ? "✓ " : ""}{u.name || u.email}
          </button>
        );
      })}
      {team.length > 1 && (
        <button type="button" onClick={() => onChange(value.length === team.length ? [] : team.map(u => ({ user_id: u._id, name: u.name || u.email })))} className="text-[11px] text-primary hover:underline ml-1" data-testid={`${testPrefix}-all`}>
          {value.length === team.length ? "Clear all" : "Select all"}
        </button>
      )}
    </div>
  );
}
